import { render, staticRenderFns } from "./ModalCreateColors.vue?vue&type=template&id=2e5cbbdb&scoped=true&"
import script from "./ModalCreateColors.vue?vue&type=script&lang=js&"
export * from "./ModalCreateColors.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateColors.vue?vue&type=style&index=0&id=2e5cbbdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5cbbdb",
  null
  
)

export default component.exports